import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "templateWorkOrderShow",
  props: { templateWorkOrderId: String },
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Template...",
    };
  },
  created() {
    this.loadTemplateWorkOrder().then(() => {
      this.dataLoaded = true;
    });
  },
  computed: {
    templateWorkOrder: function() {
      return this.$store.getters.templateWorkOrder;
    },
  },
  methods: {
    loadTemplateWorkOrder() {
      const jsConnTemplateWorkOrder = new JSConn();
      const jsConnLotUnits = new JSConn();
      const jsConnLineItems = new JSConn();

      jsConnTemplateWorkOrder.formParams = {
        id: this.templateWorkOrderId,
      };

      const dataPromises = [
        this.$store.dispatch("needTemplateWorkOrder", jsConnTemplateWorkOrder),
        this.$store.dispatch("needLotUnits", jsConnLotUnits),
        this.$store.dispatch("needLineItems", jsConnLineItems),
      ];

      return Promise.all(dataPromises);
    },
    reloadTemplateWorkOrder() {
      // as of 2019-04-27 all the child elements are emitting an event
      // that calls this function. If different things are needed for performance
      // reasons, this can be changed to handle each event separately
      return this.loadTemplateWorkOrder();
    },
  },
};
